"use strict";

require("core-js/modules/es6.array.sort");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateFlags;

var _lodash = require("lodash");

var ASSET_TYPES = _interopRequireWildcard(require("../assets/types"));

var ASSET_SUB_TYPES = _interopRequireWildcard(require("../assets/subTypes"));

var CLAIM_TYPES = _interopRequireWildcard(require("../claims/types"));

var CLAIM_SUB_TYPES = _interopRequireWildcard(require("../claims/subTypes"));

var _types3 = require("../contracts/types");

var DOCUMENT_TYPES = _interopRequireWildcard(require("../documents/types"));

var FILING_FEE_OPTIONS = _interopRequireWildcard(require("../constants/filingFeeOptions"));

var INCOME_TYPES = _interopRequireWildcard(require("../incomes/types"));

var LEGAL_ACTIONS = _interopRequireWildcard(require("../legalActions/types"));

var TRANSFER_TYPES = _interopRequireWildcard(require("../transfers/types"));

var TRANSFER_SUB_TYPES = _interopRequireWildcard(require("../transfers/subTypes"));

var _getMonthlyExpenses = _interopRequireDefault(require("../expenses/getMonthlyExpenses"));

var _getMonthlyIncome = _interopRequireDefault(require("../incomes/getMonthlyIncome"));

var _getStatePovertyLevel = _interopRequireDefault(require("../measures/getStatePovertyLevel"));

var _isWaivedFee = _interopRequireDefault(require("../measures/isWaivedFee"));

var _getFamilyAverageMonthlyNetIncome = _interopRequireDefault(require("../incomes/getFamilyAverageMonthlyNetIncome"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // 0000 - debtor/household
// 1000 - asset
// 1500 - exemptions
// 2000 - claim
// 3000 - income
// 4000 - expense
// 5000 - transfer
// 6000 - legal
// 7000 - document
// 8000 - filing
// 9000 - other


function calculateFlags() {
  var dataStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var supplements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cData = dataStore;
  var assets = cData.assets || [];
  var contracts = cData.contracts || [];
  var claims = cData.claims || [];
  var incomes = cData.incomes || [];
  var legalActions = cData.legalActions || [];
  var transfers = cData.transfers || [];
  var monthlyIncome = (0, _getMonthlyIncome["default"])(cData.incomeScheduleI);
  var monthlyExpenses = (0, _getMonthlyExpenses["default"])(cData.expenses);
  var flags = [];
  var isEmployed = incomes.find(function (i) {
    return i.type === INCOME_TYPES.EMPLOYMENT && i.endedAt == null;
  }) != null; // Files

  if (isEmployed && cData.debtor1.payRecord.reason == null && ((supplements.find(function (s) {
    return s.type === DOCUMENT_TYPES.PAY_STUB;
  }) || {}).files || []).length === 0) {
    flags.push({
      code: 7101,
      category: 'document',
      level: 'danger',
      message: 'Debtor needs a reason why pay stubs are missing.'
    });
  } else {
    flags.push({
      code: 7100,
      category: 'document',
      level: 'info',
      message: 'Debtor has paystubs or reason for them missing.'
    });
  }

  if (((supplements.find(function (s) {
    return s.type === DOCUMENT_TYPES.CERTIFICATE_OF_COUNSELING;
  }) || {}).files || []).length === 0) {
    flags.push({
      code: 7301,
      category: 'document',
      level: 'danger',
      message: 'Missing Course #1 Certificate'
    });
  } else {
    flags.push({
      code: 7300,
      category: 'document',
      level: 'info',
      message: 'Has Course #1 Certificate'
    });
  } // Assets
  // RULE: Closed Financial Accounts


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.closedAt != null;
  })) {
    flags.push({
      code: 1101,
      category: 'asset',
      level: 'warn',
      message: 'Debtor closed, sold, moved, or transferred a financial account in the last year.'
    });
  } else {
    flags.push({
      code: 1100,
      category: 'asset',
      level: 'info',
      message: 'Debtor did not close, sell, or move, or transfer a financial account in the last year.'
    });
  } // RULE: Debtor has property owned by someone else


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.OWNED_BY_ANOTHER;
  })) {
    flags.push({
      code: 1103,
      category: 'asset',
      level: 'warn',
      message: 'Someone else controls the debtor’s property.'
    });
  } else {
    flags.push({
      code: 1102,
      category: 'asset',
      level: 'info',
      message: 'No one else controls the debtor’s property.'
    });
  } // RULE: Expected to own some amount of household goods


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.PERSONAL && a.subType === ASSET_SUB_TYPES.HOUSEHOLD;
  }) == null) {
    flags.push({
      code: 1104,
      category: 'asset',
      level: 'warn',
      message: 'Debtor did not list having household good.'
    });
  } // RULE: Expect a minimal level of goods owned


  if (assets.filter(function (a) {
    return a.type === ASSET_TYPES.PERSONAL;
  }).reduce(function (accum, a) {
    return accum + (a.valueOwned || a.value);
  }, 0) <= 500) {
    flags.push({
      code: 1105,
      category: 'asset',
      level: 'warn',
      message: 'Debtor has less than $500 in personal goods.'
    });
  } // RULE: Expect jewelry


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.PERSONAL && a.subType === ASSET_SUB_TYPES.JEWELRY;
  }) == null) {
    flags.push({
      code: 1106,
      category: 'asset',
      level: 'warn',
      message: 'Debtor did not list having jewelry.'
    });
  } // RULE: Expect a security deposit


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.subType === ASSET_SUB_TYPES.SECURITY_DEPOSIT;
  }) == null) {
    flags.push({
      code: 1108,
      category: 'asset',
      level: 'warn',
      message: 'Debtor did not indicate having any security deposit, which most people have.'
    });
  } else {
    flags.push({
      code: 1107,
      category: 'asset',
      level: 'info',
      message: 'Debtor listed a security deposit.'
    });
  } // RULE: Make sure we understand context around money owed


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.subType === ASSET_SUB_TYPES.INTEREST_FROM_DEATH;
  })) {
    flags.push({
      code: 1110,
      category: 'asset',
      level: 'warn',
      message: 'Debtor has right to money from someone who died.'
    });
  } else {
    flags.push({
      code: 1109,
      category: 'asset',
      level: 'info',
      message: 'Debtor is not owed money from someone who died.'
    });
  } // RULE: Possible legal settlements need to be understood more


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.subType === ASSET_SUB_TYPES.CLAIM;
  })) {
    flags.push({
      code: 6011,
      category: 'legal',
      level: 'warn',
      message: 'Debtor has right to sue someone for money.'
    });
  } else {
    flags.push({
      code: 6010,
      category: 'legal',
      level: 'info',
      message: 'Debtor is not able to sue someone for money.'
    });
  } // RULE: Money owed needs to be understood more


  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.subType === ASSET_SUB_TYPES.FINANCIAL_OWED;
  })) {
    flags.push({
      code: 1112,
      category: 'asset',
      level: 'warn',
      message: 'Debtor owed money for something else.'
    });
  } else {
    flags.push({
      code: 1111,
      category: 'asset',
      level: 'info',
      message: 'Debtor doesn\'t owe money to something else.'
    });
  }

  if (assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.subType === ASSET_SUB_TYPES.CONTINGENT_CLAIM;
  })) {
    flags.push({
      code: 1114,
      category: 'asset',
      level: 'warn',
      message: 'Debtor owed money for a claim.'
    });
  } else {
    flags.push({
      code: 1113,
      category: 'asset',
      level: 'info',
      message: 'Debtor not owed for a claim.'
    });
  } // RULE: High value assets are a possible issue


  assets.filter(function (a) {
    return a.valueOwned != null ? a.valueOwned >= 5000 : (a.value || a.valueOwned) >= 5000;
  }).forEach(function (a) {
    flags.push({
      code: 1115,
      category: 'asset',
      level: 'warn',
      message: "Asset worth over $5,000: ".concat((a.subType || '').replace(/_/g, ' ')),
      data: a
    });
  }); // RULE: Everyone has some amount of cash. Looks weird

  if ((assets.find(function (a) {
    return a.type === ASSET_TYPES.FINANCIAL && a.subType === ASSET_SUB_TYPES.CASH;
  }) || {}).value <= 5) {
    flags.push({
      code: 1116,
      category: 'asset',
      level: 'warn',
      message: 'The debtor listed less than $5 in cash.'
    });
  } // Exemptions
  // RULE: Stop people with tax refunds that are not totally covered (1k+)


  if (assets.find(function (a) {
    return a.subType === ASSET_SUB_TYPES.TAX_REFUND && a.value - (a.exemptions || []).reduce(function (accum, ex) {
      return accum + ex.value;
    }, 0) >= 1000;
  })) {
    flags.push({
      code: 1501,
      category: 'exemptions',
      level: 'danger',
      message: 'Tax refunds have greater than $1,000 in value unexempted.'
    });
  } // Claims
  // RULE: Expect spouse as codebtor


  if (cData.married && cData.codebtors.length === 0) {
    flags.push({
      code: 2000,
      category: 'claim',
      level: 'warn',
      message: 'Debtor indicated that they are currently married, but did not list any codebtors.'
    });
  } // RULE: We're handling consumer debt cases


  if (cData.debtsPrimarilyConsumer === true) {
    flags.push({
      code: 2002,
      category: 'claim',
      level: 'info',
      message: 'Debtor owes primarily consumer debt.'
    });
  } else {
    flags.push({
      code: 2001,
      category: 'claim',
      level: 'warn',
      message: 'Debtor doesn’t owe primarily consumer debt.'
    });
  }

  if (claims.find(function (c) {
    return c.type === CLAIM_TYPES.SECURED;
  }) && assets.find(function (a) {
    return a.type === CLAIM_SUB_TYPES.AUTOMOBILE;
  })) {
    flags.push({
      code: 2003,
      category: 'claim',
      level: 'warn',
      message: 'Debtor has secured debt and vehicle(s)'
    });
  }

  if (claims.filter(function (c) {
    return c.subType !== CLAIM_SUB_TYPES.EDUCATION;
  }).reduce(function (accum, c) {
    return accum + c.value;
  }, 0) < 10000) {
    flags.push({
      code: 2004,
      category: 'claim',
      level: 'warn',
      message: "The debtor has less than $10,000 in unsecured debt. Their reason for filing:\n      \"".concat(cData.filingReason || '', "\"")
    });
  }

  if (claims.filter(function (c) {
    return c.subType === CLAIM_SUB_TYPES.GOVERNMENT;
  }).reduce(function (accum, c) {
    return accum + c.value;
  }, 0) / (claims.reduce(function (accum, c) {
    return accum + c.value;
  }, 0) / 2)) {
    flags.push({
      code: 2006,
      category: 'claim',
      level: 'warn',
      message: 'Debtor has over 50% tax debts.'
    });
  } else {
    flags.push({
      code: 2005,
      category: 'claim',
      level: 'info',
      message: 'Debtor has less than 50% tax debts.'
    });
  } // RULE: Creditors need addresses to be notified


  var addressesMissing = 0;
  claims.forEach(function (c) {
    if (((0, _lodash.get)(c, 'creditor.address.street1') || '').length === 0 || ((0, _lodash.get)(c, 'creditor.address.city') || '').length === 0) {
      addressesMissing += 1;
    }
  });

  if (addressesMissing > 0) {
    flags.push({
      code: 2008,
      category: 'claim',
      level: 'danger',
      message: "".concat(addressesMissing, " creditor addresses missing an street 1 or city.")
    });
  } else {
    flags.push({
      code: 2007,
      category: 'claim',
      level: 'info',
      message: 'All creditors have addresses.'
    });
  } // RULE: Secured debts cannot reference leased assets.


  var securedAssetLeased = false; // Check relations on secured claims

  claims.filter(function (claim) {
    return claim.type === CLAIM_TYPES.SECURED;
  }).forEach(function (claim) {
    var collateralAsset = assets.find(function (asset) {
      return asset.id === claim.assetId;
    });
    var collateralAssetLease = collateralAsset != null ? contracts.find(function (contract) {
      return collateralAsset.contractId === contract.id && contract.type === _types3.LEASE;
    }) : null; // Check if associated asset has an associated contract

    if (collateralAssetLease != null) securedAssetLeased = true;
  });

  if (securedAssetLeased === true) {
    flags.push({
      code: 2010,
      category: 'claim',
      level: 'warn',
      message: 'A secured debt is using a leased asset as collateral.'
    });
  } else {
    flags.push({
      code: 2009,
      category: 'claim',
      level: 'info',
      message: 'Leased assets are not attached to secured debts.'
    });
  } // Legal


  if (transfers.find(function (t) {
    return t.type === TRANSFER_TYPES.INSIDER;
  })) {
    flags.push({
      code: 5001,
      category: 'transfer',
      level: 'warn',
      message: 'Debtor made payment to insider in last year.'
    });
  } else {
    flags.push({
      code: 5000,
      category: 'transfer',
      level: 'info',
      message: 'Debtor has not paid an insider in last year.'
    });
  }

  if (transfers.find(function (t) {
    return t.type === TRANSFER_TYPES.INSIDER && t.benefit === true;
  })) {
    flags.push({
      code: 5003,
      category: 'transfer',
      level: 'warn',
      message: 'Debtor made payment to benefit an insider in last year.'
    });
  } else {
    flags.push({
      code: 5002,
      category: 'transfer',
      level: 'info',
      message: 'Debtor has made a payment to benefit an insider in last year.'
    });
  }

  if (legalActions.find(function (la) {
    return la.type === LEGAL_ACTIONS.CASE;
  })) {
    flags.push({
      code: 6001,
      category: 'legal',
      level: 'warn',
      message: 'Debtor was involved in a lawsuit or court action in last year.'
    });
  } else {
    flags.push({
      code: 6000,
      category: 'legal',
      level: 'info',
      message: 'Debtor was not involved in a lawsuit or court action in last year.'
    });
  }

  if (legalActions.find(function (la) {
    return la.type === TRANSFER_TYPES.CONTRIBUTION;
  })) {
    flags.push({
      code: 6003,
      category: 'legal',
      level: 'warn',
      message: 'Debtor gave a personal gift over $600 in last two years.'
    });
  } else {
    flags.push({
      code: 6002,
      category: 'legal',
      level: 'info',
      message: 'Debtor gave no personal gifts over $600 in last two years.'
    });
  }

  if (legalActions.find(function (la) {
    return la.type === LEGAL_ACTIONS.CONSULT;
  })) {
    flags.push({
      code: 6005,
      category: 'legal',
      level: 'warn',
      message: 'Debtor has consulted with a lawyer in the past 3 years. Look for lawsuits as' + ' the debtor may have a settlement claim coming that the trustee could try to seize.'
    });
  } else {
    flags.push({
      code: 6004,
      category: 'legal',
      level: 'info',
      message: 'Debtor hasn\'t consulted with a lawyer in the past 3 years.'
    });
  }

  if (transfers.find(function (t) {
    return t.type === TRANSFER_TYPES.LOSS;
  })) {
    flags.push({
      code: 5005,
      category: 'transfer',
      level: 'warn',
      message: 'Debtor lost property in a theft, fire, other disaster, or gambling loss in the last year.'
    });
  } else {
    flags.push({
      code: 5004,
      category: 'transfer',
      level: 'info',
      message: 'Debtor has not lost property in a theft, fire, other disaster, or gambling loss in the last year.'
    });
  }

  if (transfers.find(function (t) {
    return t.type === TRANSFER_TYPES.CONSULTANT && t.subType === TRANSFER_SUB_TYPES.BANKRUPTCY;
  })) {
    flags.push({
      code: 5007,
      category: 'transfer',
      level: 'warn',
      message: 'Debtor transferred property for bankruptcy help.'
    });
  } else {
    flags.push({
      code: 5006,
      category: 'transfer',
      level: 'info',
      message: 'Debtor has not transferred property for bankruptcy help.'
    });
  }

  if (transfers.find(function (t) {
    return t.type === TRANSFER_TYPES.CONSULTANT && t.subType === TRANSFER_SUB_TYPES.CREDITOR;
  })) {
    flags.push({
      code: 5008,
      category: 'transfer',
      level: 'warn',
      message: 'Debtor made payments to someone who promised to pay creditors.'
    });
  } else {
    flags.push({
      code: 5009,
      category: 'transfer',
      level: 'info',
      message: 'Debtor did not pay someone who promised to pay creditors.'
    });
  }

  if (transfers.find(function (t) {
    return t.type === TRANSFER_TYPES.INDIVIDUAL;
  })) {
    flags.push({
      code: 5011,
      category: 'transfer',
      level: 'warn',
      message: 'Debtor transferred property outside regular activities in last two years.'
    });
  } else {
    flags.push({
      code: 5010,
      category: 'transfer',
      level: 'info',
      message: 'Debtor did not transfer property outside regular activities in last two years.'
    });
  }

  if (cData.violateenvironmentallaw) {
    flags.push({
      code: 6006,
      category: 'legal',
      level: 'warn',
      message: 'Debtor violated environmental law.'
    });
  }

  if (cData.hazardousmaterialrelease) {
    flags.push({
      code: 6007,
      category: 'legal',
      level: 'warn',
      message: 'Debtor released hazardous material.'
    });
  }

  if (cData.enviornmentaladminproceeding) {
    flags.push({
      code: 6008,
      category: 'legal',
      level: 'warn',
      message: 'Debtor is involved in a proceeding under environmental law.'
    });
  } // Income
  // If any debtors are employed but have $0 income, flag it
  // Check debtor 1


  if (incomes.find(function (i) {
    return i.type === INCOME_TYPES.EMPLOYMENT && i.endedAt == null && i.interest === 'debtor1';
  }) && !(0, _lodash.get)(cData, 'incomeScheduleI.debtor1.valueIncome')) {
    flags.push({
      code: 3000,
      category: 'income',
      level: 'warn',
      message: 'Debtor 1 claimed employment but listed no employment income.'
    });
  } // Check debtor 2


  if (incomes.find(function (i) {
    return i.type === INCOME_TYPES.EMPLOYMENT && i.endedAt == null && i.interest === 'debtor2';
  }) && !(0, _lodash.get)(cData, 'incomeScheduleI.debtor2.valueIncome')) {
    flags.push({
      code: 3001,
      category: 'income',
      level: 'warn',
      message: 'Debtor 2 claimed employment but listed no employment income.'
    });
  }

  if ((0, _lodash.get)(cData, 'incomeScheduleI.debtor1.valueTakeHomePay', 0) > (0, _lodash.get)(cData, 'incomeScheduleI.debtor1.valueGrossIncome', 0) * 0.85) {
    flags.push({
      code: 3003,
      category: 'income',
      level: 'warn',
      message: "Debtor listed fewer payroll deductions than most people. Net Monthly: $".concat((0, _lodash.get)(cData, 'incomeScheduleI.debtor1.valueTakeHomePay', 0), " - Gross Monthly: $").concat((0, _lodash.get)(cData, 'incomeScheduleI.debtor1.valueGrossIncome', 0))
    });
  } else {
    flags.push({
      code: 3002,
      category: 'income',
      level: 'info',
      message: 'Payroll deductions seem appropriate.'
    });
  }

  if (monthlyIncome - monthlyExpenses >= 40) {
    flags.push({
      code: 3004,
      category: 'income',
      level: 'danger',
      message: 'Debtor has a $40 income surplus after expenses.'
    });
  }

  if ((0, _lodash.get)(cData, 'incomeScheduleI.debtor1.monthlyIncome', 0) < 2665 && (0, _lodash.get)(cData, 'incomeScheduleI.debtor1.otherGovAssistanceNames', '').replace(/[^a-zA-Z\s]/gi, '').toLowerCase().includes('snap') === false) {
    flags.push({
      code: 3005,
      category: 'income',
      level: 'warn',
      message: 'Even though debtor seems eligible for SNAP, they did not list them.'
    });
  } // Expenses


  if (monthlyExpenses - monthlyIncome >= 1000) {
    flags.push({
      code: 4000,
      category: 'expense',
      level: 'danger',
      message: 'Debtor has expenses that are $1,000+ greater than income.'
    });
  }

  if (cData.renter && cData.expenses.propertyExpenses.reduce(function (accum, e) {
    return accum + e.mortgageRent;
  }, 0) > 0) {
    flags.push({
      code: 4002,
      category: 'expense',
      level: 'warn',
      message: 'Debtor indicated they are a renter but did not list any rent expense.'
    });
  } else {
    flags.push({
      code: 4001,
      category: 'expense',
      level: 'info',
      message: 'Debtor listed rental expenses with their renter status.'
    });
  } // Fee Waiver


  var householdSize = 1 + (cData.married === true ? 1 : 0) + (0, _lodash.get)(cData, 'household.dependents', []).length;
  var eligibleForWaiver = (0, _lodash.get)(cData, 'incomeScheduleI.debtor1') != null ? (0, _isWaivedFee["default"])((0, _getFamilyAverageMonthlyNetIncome["default"])(cData), (0, _lodash.get)(cData, 'debtor1.address.state'), householdSize) : null;

  if ((0, _lodash.get)(cData, 'filingFee.method') === FILING_FEE_OPTIONS.WAIVER && eligibleForWaiver === false) {
    flags.push({
      code: 8000,
      category: 'filing',
      level: 'warn',
      message: 'Debtor is requesting fee waiver but is over 150% the poverty level.'
    });
  }

  if ((0, _lodash.get)(cData, 'filingFee.method') !== FILING_FEE_OPTIONS.WAIVER && eligibleForWaiver === true) {
    flags.push({
      code: 8001,
      category: 'filing',
      level: 'warn',
      message: "Debtor appears eligble for fee waiver, but is not requesting one. (%150 PL for ".concat((0, _lodash.get)(cData, 'debtor1.address.state'), " = $").concat((0, _getStatePovertyLevel["default"])((0, _lodash.get)(cData, 'debtor1.address.state'), householdSize, 1.5), " > $").concat((0, _lodash.get)(cData, 'incomeMeansTest.debtor1.valueTotalMonthlyIncome', 0) + (cData.married === false || cData.separateHouseholds === true ? 0 : (0, _lodash.get)(cData, 'incomeMeansTest.debtor2.valueTotalMonthlyIncome', 0)), " Monthly Income)")
    });
  } // Return !!!


  return flags.sort(function (a, b) {
    // Danger is top
    if (a.level === 'danger') return -1; // Then switch around info/warning

    if (a.level === 'info') return 1;
    if (b.level === 'info') return -1;
    return 0;
  });
}